export default __webpack_public_path__ + "static/media/lg2.f9d01f23.jpg";